{
  "version": 1,
  "asset_id": "fe28b337-8153-4e01-91f7-44eb539eb2f1",
  "project_id": "affbb9b7-8892-4de7-a6a3-a24f8c559459",
  "url": "/__l5e/assets-v1/fe28b337-8153-4e01-91f7-44eb539eb2f1/scala-in-cotto-antico-pulita.webp",
  "r2_key": "a/v1/affbb9b7-8892-4de7-a6a3-a24f8c559459/fe28b337-8153-4e01-91f7-44eb539eb2f1/scala-in-cotto-antico-pulita.webp",
  "original_filename": "scala-in-cotto-antico-pulita.webp",
  "size": 231384,
  "content_type": "image/webp",
  "created_at": "2026-08-13T06:52:31Z"
}
